import { state } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'

import { Dispensary } from './types'

const [dispensaryChange$, setDispensary] = createSignal<Dispensary | undefined>()

export { setDispensary }

export const latestDispensary$ = state(dispensaryChange$, null)

const [eScriptCartUpdateStatusChange$, setEScriptCartUpdateStatus] = createSignal<
  'idle' | 'in_progress'
>()

export { setEScriptCartUpdateStatus }

export const latestEScriptCartUpdateStatus = state(eScriptCartUpdateStatusChange$, 'idle')
